import React, { useContext } from "react";
import Context from "../context/CartContext";
import { cargaProveedorUnico } from "../services/proveedores.jsx";
import ContextProveedor from "../context/ProveedorContext";
import { useNavigate } from "react-router-dom";

export default function Sidebar() {
  const { cart, setCart } = useContext(Context);
  const { setProveedorContext } = useContext(ContextProveedor);
  const navigate = useNavigate();
  const cantidadTotal = cart.reduce((total, item) => total + item.cantidad, 0);

  const vaciarProducto = (id_producto) => {
    setCart((prev) => prev.filter((item) => item.id_producto !== id_producto));
  };

  const handleClickMostrarCarro = async () => {
    if (cart.length !== 0) {
      try {
        const id = document.getElementById("cboProveedor").value;
        const proveedor = await cargaProveedorUnico(id);
        setProveedorContext(proveedor);
        const sidebar = document.getElementById("offcanvasRight");
        if (sidebar) sidebar.classList.add("translate-x-full");
        document.body.style = "";
        navigate("/confirmar");
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <div
      id="offcanvasRight"
      className="fixed top-0 right-0 h-full w-full sm:w-96 bg-surface-card shadow-card-lg z-[60] transform translate-x-full transition-transform duration-300 flex flex-col"
    >
      <div className="flex items-center justify-between p-4 bg-gradient-to-r from-pons-500 to-pons-600">
        <h5 className="text-white font-bold text-lg">Carrito de Solicitud</h5>
        <button
          onClick={() => document.getElementById("offcanvasRight").classList.add("translate-x-full")}
          className="text-white/80 hover:text-white p-1 rounded-lg hover:bg-white/10 transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        {cart.length === 0 ? (
          <div className="text-center py-12">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto text-ink-light mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 100 4 2 2 0 000-4z" />
            </svg>
            <p className="text-ink-muted font-medium">El carrito esta vacio</p>
          </div>
        ) : (
          cart.map((element) => (
            <div
              key={element.id_producto}
              className="bg-surface-page rounded-xl p-3 border border-surface-border sidebar-item-enter"
            >
              <div className="flex gap-3">
                <img
                  src={"https://storage.googleapis.com/imagenes-ponsrazas/" + element.imagen}
                  alt={element.producto_nombre}
                  className="w-16 h-16 object-contain rounded-lg bg-white flex-shrink-0"
                />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-ink truncate">
                    {element.producto_nombre} {element.numeracion} {element.medidaOficial}
                  </p>
                  <p className="text-xs text-ink-muted">{element.marca_nombre}</p>
                  <p className="text-sm font-bold text-pons-700 mt-1">
                    Cantidad: {element.cantidad}
                  </p>
                </div>
                <button
                  onClick={() => vaciarProducto(element.id_producto)}
                  className="self-start text-danger/70 hover:text-danger transition-colors flex-shrink-0"
                  title="Eliminar"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      <div className="p-4 border-t border-surface-border bg-gradient-to-r from-pons-500 to-pons-600">
        <div className="flex items-center justify-between text-white mb-3">
          <span className="text-sm font-medium">Total Productos:</span>
          <span className="text-xl font-bold">{cantidadTotal}</span>
        </div>
        <button
          className="w-full bg-white text-pons-700 font-bold py-3 rounded-xl hover:bg-pons-100 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-soft"
          onClick={handleClickMostrarCarro}
          disabled={cart.length === 0}
        >
          Confirmar Carro
        </button>
      </div>
    </div>
  );
}
